export enum CompatVersion {
  // we can comment out old versions, after new ones have been released.
  // V0_0 = "v0.0", // decibel-testnet-release-v0.0
  // V0_1 = "v0.1", // decibel-testnet-release-v0.1
  // V0_2_PARTIAL = "v0.2.partial", // decibel-testnet-release-v0.2
  // V0_2 = "v0.2", // decibel-release-v0.12
  // V0_3 = "v0.3", // decibel-testnet-release-v0.3
  V0_4 = "v0.4", // decibel-testnet-release-v0.4 - and final version.
}

export interface ReleaseConfig {
  compatVersion: CompatVersion;
}

export const PACKAGE = {
  // Deterministic publisher address for localnet/docker deploys.
  LOCAL: "0xb8a5788314451ce4d2fbbad32e1bad88d4184b73943b7fe5166eab93cf1a5a95",
  TESTNET: "0xd368b820fdfbfe004679cdb0facef4b920c4fc0c2c80bd2fecf3843a93427bd1",
  // Same address on testnet and mainnet.
  PREDEPOSIT: "0xc5939ec6e7e656cb6fed9afa155e390eb2aa63ba74e73157161829b2f80e1538",
  MAINNET: "0x50ead22afd6ffd9769e3b3d6e0e64a2a350d68e8b102c4e72e33d0b8cfdfdb06",
  CAMPAIGN_TESTNET: "0x6c8e3171c638045f765e1d66e8e71e819eaf0afa54d1914db3c37f3b02a9c5b3",
  CAMPAIGN_MAINNET: "0x7dd60d4445490318a073a600d6109ff587d21e634a22ea08a1b154cc591b3cf4",
};

export const DEFAULT_COMPAT_VERSION = CompatVersion.V0_4;

const TESTNET_RELEASE_CONFIG: ReleaseConfig = {
  compatVersion: CompatVersion.V0_4,
};

const LOCAL_RELEASE_CONFIG: ReleaseConfig = {
  compatVersion: DEFAULT_COMPAT_VERSION,
};

const DOCKER_RELEASE_CONFIG: ReleaseConfig = {
  compatVersion: DEFAULT_COMPAT_VERSION,
};

const MAINNET_RELEASE_CONFIG: ReleaseConfig = {
  compatVersion: CompatVersion.V0_4,
};

export const RELEASE_CONFIGS = {
  TESTNET: TESTNET_RELEASE_CONFIG,
  LOCAL: LOCAL_RELEASE_CONFIG,
  DOCKER: DOCKER_RELEASE_CONFIG,
  MAINNET: MAINNET_RELEASE_CONFIG,
};
